import ROUTE from "@app/navigationApp/routes";
import Button from "@app/sharedComponents/Button/Button";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme"
import { formatIndianCurrency } from "@app/utils/utility";
import { WarningCircle, Info } from '@app/sharedComponents/Icons/Icons';
import { ScrollView,Image } from "react-native"
import Accordion from "@app/sharedComponents/Accordion/Accordion";
import useSingleRemoteConfig from "@app/hooks/useSingleRemoteConfig";
import { useMemo, useState } from "react";
import TooltipComp from "@app/sharedComponents/ToolTip/Tooltip";
import { useAppSelector } from "@app/store/hooks";
import { LENDER_ID } from "@app/types/regix";
import { isCurrentTimeAfterSixPM } from "@app/utils/utils";
export const SHORTFALL_RUPEE='https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Shortfall_rupee.png';

const ShortfallDetail = ({navigation,route})=>{
    const [showToolTip, setShowToolTip] = useState(false);
    const [triggerOpen, setTriggerOpen] = useState(false);
    const shortFallDetails = useAppSelector((state) => state.auth.shortFallDetails);
    const {shortfallAmount,drawingPower,principalOutstandingAmount,daysLeft,lenderId} = shortFallDetails;    
    const {configValue , loading : faqLoading} = useSingleRemoteConfig('shortfall_card_faq')
    const faqData  = configValue ? JSON.parse(configValue).splice(0,6)  : []

    const { shortfallDesc, allowRepay } = useMemo(() => {
        let shortfallDesc = '';
        let allowRepay = true;
        if(shortFallDetails?.daysLeft > 1){
            if(shortFallDetails?.lenderId === 'Tata')
                shortfallDesc = `${shortFallDetails?.daysLeft} DAYS LEFT TO MEET SHORTFALL`
            else shortfallDesc = `${shortFallDetails?.daysLeft} WORKING DAYS LEFT TO MEET SHORTFALL`
        }
        else if(shortFallDetails?.daysLeft === 1){
            const isAfterSixPM = isCurrentTimeAfterSixPM();
            if(isAfterSixPM){
                shortfallDesc = 'SHORTFALL DEADLINE HAS EXPIRED'
                allowRepay = false;
            } else {
                shortfallDesc = 'MEET SHORTFALL BEFORE 6 PM'
            }
        }
        else {
            shortfallDesc = `PORTFOLIO SELL-OFF INITIATED`
            allowRepay = false;
        }
        return { shortfallDesc, allowRepay };
    }, [shortFallDetails]);


    
    return(
        <>
        <PageHeaders pageName={route?.name} label="Shortfall" navigation={navigation} triggerOpen={triggerOpen} setTriggerOpen={setTriggerOpen}/>
        <ScrollView style={{backgroundColor:themeColorSet['bg-surface-page']}}>
            <ThemedView mt="2xl">
                <ThemedView flexDirection="row" px="lg" py="xs" backgroundColor="bg-fill-error" alignItems="center">
                    <WarningCircle weight="fill" size={16} color={themeColorSet["icon-error"]} />
                    <ThemedText ml="sm" color="text-error" variant="b4s" textTransform="uppercase">
                        {shortfallDesc}
                    </ThemedText>
                </ThemedView>
                <ThemedView backgroundColor="bg-surface-primary" p="lg"   borderBottomWidth={1} borderColor="border-primary">
                    <ThemedView backgroundColor="bg-surface-primary" p="lg"  borderWidth={1} borderColor="border-primary"borderRadius="sm">
                    <ThemedView flexDirection="row" alignItems="center">

                    <Image
                        source={{uri:SHORTFALL_RUPEE}}
                        style={{width: 52, height: 52}}
                    />
                    <ThemedView ml="md">
                        <ThemedText variant="b3r" color="text-secondary">Shortfall amount</ThemedText>
                        <ThemedView flexDirection="row" alignItems="center">
                            <ThemedText variant="l2" color="text-error">₹</ThemedText>
                            <ThemedText variant="h2s" color="text-error">{formatIndianCurrency(shortfallAmount)}</ThemedText>
                        </ThemedView>
                    </ThemedView>
                    </ThemedView>

                    <ThemedView backgroundColor="bg-fill-info" p="sm" mt="lg" borderRadius="sm" flexDirection="row">
                        <Info weight="fill" size={16} color={themeColorSet['icon-secondary']} />
                        <ThemedText variant="b4r" color='text-secondary' ml="sm">What is shortfall?</ThemedText>
                        <ThemedPressable onPress={()=>navigation.navigate(ROUTE.WHAT_IS_SHORTFALL,{daysLeft})}>
                            <ThemedText color="text-action-primary" variant="b4s"> Learn more</ThemedText>
                        </ThemedPressable>
                    </ThemedView>
                    </ThemedView>
                   
                </ThemedView>
                <ThemedView backgroundColor="bg-surface-primary" p="lg" my="lg" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary">
                    <ThemedText variant="b2s" color="text-primary" mb="md">Shortfall details</ThemedText>
                    <ThemedView backgroundColor="bg-surface-primary" p="lg"  borderWidth={1} borderColor="border-primary" borderRadius="sm">
                        <ThemedView  flexDirection="row" justifyContent="space-between">
                            <ThemedView flexDirection="row" alignItems="center"> 
                                <ThemedText variant="b3r" color="text-secondary">Revised credit limit </ThemedText>
                                <ThemedPressable onPress={()=>setShowToolTip(!showToolTip)}>
                                    <Info size={16} color={themeColorSet['icon-secondary']} />
                                    {showToolTip &&
                                        <TooltipComp
                                        title="Revised credit limit is based on the current market value of your pledged mutual funds"
                                        leftShiftContent={-135}
                                        />}
                                </ThemedPressable>
                            </ThemedView>
                            <ThemedText variant="b3r" color="text-primary">₹{formatIndianCurrency(drawingPower)}</ThemedText>
                        </ThemedView>
                        <ThemedView my="md" height={1} backgroundColor="border-secondary"/>
                        <ThemedView  flexDirection="row" justifyContent="space-between">
                            <ThemedText variant="b3r" color="text-secondary">Outstanding amount</ThemedText>
                            <ThemedText variant="b3r" color="text-primary">₹{formatIndianCurrency(principalOutstandingAmount)}</ThemedText>
                        </ThemedView>
                        <ThemedView my="md" height={1} backgroundColor="border-secondary"/>
                        <ThemedView  flexDirection="row" justifyContent="space-between">
                            <ThemedText variant="b3s" color="text-primary">Shortfall amount</ThemedText>
                            <ThemedText variant="b3s" color="text-error">₹{formatIndianCurrency(shortfallAmount)}</ThemedText>
                        </ThemedView>
                    </ThemedView>
                </ThemedView>
                <ThemedView backgroundColor="bg-surface-primary" p="lg" mb="lg" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary">
                <ThemedText variant="b2s" color="text-primary" mb="lg">Frequently asked questions</ThemedText>
                    {
                        faqData.map(item=>{
                            return(
                                <Accordion
                                    id={item.id}
                                    description={item.description}
                                    title={item.title}
                                />
                            )
                        })
                    }
                </ThemedView>
            </ThemedView>
        </ScrollView>
        <ThemedView backgroundColor="bg-surface-primary" p="lg" pt="2xl" borderTopWidth={1} borderColor="border-primary">
            {
            allowRepay ?
            <Button size="MD" label="Proceed to repay" handlePress={()=>navigation.navigate(ROUTE.SHORTFALL_REPAY,{shortFallDetails:route?.params?.shortFallDetails})}/>
            :
            <Button size="MD" label="Need help? Contact Support" handlePress={()=>setTriggerOpen(true)}/>
            }
        </ThemedView>
        </>
    )
}

export default ShortfallDetail